import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, TimePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import moment from "moment-timezone";
import ProdutoFrame from './ProdutoFrame';
import { maskDate } from "../utils/Masker";
import { getUsuario } from "../utils/LoginManager";

const formatHora = 'HH:mm';
const { Item: ItemForm } = Form;

export default class OrdemProducaoItemForm extends Component {
  state = {
    editando: false,
    listaProdutos: [],
    registro: {
      pi_seq: 0,
      pi_item: { key: '0' },
      prod_codigo: '',
      prod_descricao: '',
      pi_qtde: 1,
      pi_peso_real: 1,
      pi_dt_producao: moment().format('DD/MM/YYYY'),
      pi_dt_entrega: moment().format('DD/MM/YYYY'),
      pi_hora: '00:00',
      pi_obs: '',
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.produtoSelecionado !== propsAnterior.produtoSelecionado) {
      this.setState({
        registro: this.props.produtoSelecionado.registro,
        listaProdutos: this.props.produtoSelecionado.listaProdutos ? this.props.produtoSelecionado.listaProdutos : [],
        editando: this.props.produtoSelecionado.editando,
      }, () => {
        this.forceUpdate();
      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
  }


  onOK = () => {
    const { pi_seq, pi_item, pi_qtde, pi_peso_real, pi_dt_producao, pi_dt_entrega, pi_obs } = this.state.registro;

    let iIndProd = -1;
    if ((!pi_item) || (pi_item.key === '0') || (pi_item.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
      return;
    }
    if (!pi_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade' });
      return;
    }
    if (!pi_peso_real) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Peso' });
      return;
    }
    if ((!this.state.registro.pi_dt_producao) || (!moment(this.state.registro.pi_dt_producao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Produção Válida' });
      return;
    }
    if ((!this.state.registro.pi_dt_entrega) || (!moment(this.state.registro.pi_dt_entrega, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Entrega Válida' });
      return;
    }


    let iIndItem = -1;
    for (var x in this.state.listaProdutos) {
      if (String(this.state.listaProdutos[x].pi_item) === String(pi_item.key)) {
        iIndItem = x;
      }
    }

    // console.log('onOK: ', iIndItem);

    if (iIndItem >= 0) {

      this.state.listaProdutos[iIndItem].pi_qtde = parseFloat(pi_qtde);
      this.state.listaProdutos[iIndItem].pi_peso_real = parseFloat(pi_peso_real);
      this.state.listaProdutos[iIndItem].pi_dt_producao = moment(pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.state.listaProdutos[iIndItem].pi_dt_entrega = moment(pi_dt_entrega, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.state.listaProdutos[iIndItem].pi_obs = pi_obs ? pi_obs : '';

    } else {

      this.state.listaProdutos.push({
        ven_idf: 0,
        pi_item: pi_item.key,
        pi_seq: this.state.listaProdutos.length + 1,
        prod_idf: pi_item.key,
        prod_codigo: pi_item.prod_codigo,
        prod_descricao: pi_item.prod_descricao,
        pi_qtde: parseFloat(pi_qtde),
        pi_peso_real: parseFloat(pi_peso_real),
        pi_dt_producao: moment(pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        pi_dt_entrega: moment(pi_dt_entrega, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        pi_obs: pi_obs ? pi_obs : '',
      });

    }

    this.props.onSalvarProdutoClick(this.state.listaProdutos);
  };



  onChangeProduto = event => {
    const { registro } = this.state;
    registro['pi_item'] = event.pi_item;

    if (this.state.usuario.par_flag_produto_peso_conver) {
      registro['pi_peso_real'] = parseFloat(this.state.registro.pi_qtde) * (event.pi_item.prod_peso ? parseFloat(event.pi_item.prod_peso) : 1) * (event.pi_item.prod_medida2_conversao ? parseFloat(event.pi_item.prod_medida2_conversao) : 1);
    }

    this.setState(event);
  }


  onInputChangeQtde = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;

    registro[id] = value;

    // console.log('onInputChangeQtde', value)
    // console.log('onInputChangeQtde', this.state.registro.pi_item)

    if (this.state.usuario.par_flag_produto_peso_conver) {
      if (this.state.registro.pi_item) {
        const peso = (this.state.registro.pi_item.prod_peso ? parseFloat(this.state.registro.pi_item.prod_peso) : 1);
        // const conversao = (this.state.registro.pi_item.prod_medida2_conversao ? parseFloat(this.state.registro.pi_item.prod_medida2_conversao) : 1);
        // console.log('onInputChangeQtde1', peso)
        // console.log('onInputChangeQtde1', conversao)
        registro['pi_peso_real'] = parseFloat(value) * peso;
      } else {
        console.log('onInputChangeQtde2')
        registro['pi_peso_real'] = value;
      }
    } else {
      console.log('onInputChangeQtde3')
      registro['pi_peso_real'] = value;
    }

    this.setState({
      [id]: value
    });
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onInputChangeHora = (time, timeString) => {
    this.setState({
      registro: {
        ...this.state.registro,
        pi_hora: timeString ? timeString : '00:00',
      },
    });
  }




  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalProdutoClick, visivel } = this.props;

    const { editando } = this.state;
    const { pi_item, pi_qtde, pi_peso_real, pi_dt_producao, pi_dt_entrega, pi_hora, pi_obs } = this.state.registro;

    // console.log('OrdemProducaoItemForm.this.state: ', this.state);

    return (
      <Modal
        title={editando ? "Editar Produto" : "Incluir Produto"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalProdutoClick}
        footer={null}
        width={"50%"}
        style={{ top: 50 }}
      >
        <div>

          <Row>

            <Col xs={24}>
              <ProdutoFrame
                label="Produto"
                id="pi_item"
                value={pi_item}
                width={"100%"}
                onChange={this.onChangeProduto}
                descricaoPrimeiroItem="Selecione um Produto"
              />
            </Col>
            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde</span>
              <InputForm
                type="number"
                id="pi_qtde"
                ref="pi_qtde"
                value={pi_qtde}
                onChange={this.onInputChangeQtde}
              />
            </Col>
            {this.state.usuario && this.state.usuario.par_flag_produto_peso_conver ? (
              <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Peso Real</span>
                <InputForm
                  type="number"
                  id="pi_peso_real"
                  ref="pi_peso_real"
                  value={pi_peso_real}
                  disabled={true}
                />
              </Col>
            ) : null}
            <Col xs={24} sm={8} style={{ marginTop: -18 }}>
              <span>Data Produção</span>
              <InputForm
                type="date"
                id="pi_dt_producao"
                ref="pi_dt_producao"
                value={pi_dt_producao}
                masker={maskDate}
                validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                dateFormat="DD/MM/YYYY"
                onChange={this.onChange}
                errorMessage="Formato correto DD/MM/AAAA"
                className="input-data-avaliacao"
              // style={{ width: "100%" }}
              />
            </Col>
            <Col xs={24} sm={8} style={{ marginTop: -18 }}>
              <span>Data Entrega</span>
              <InputForm
                type="date"
                id="pi_dt_entrega"
                ref="pi_dt_entrega"
                value={pi_dt_entrega}
                masker={maskDate}
                validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                dateFormat="DD/MM/YYYY"
                onChange={this.onChange}
                errorMessage="Formato correto DD/MM/AAAA"
                className="input-data-avaliacao"
              // style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={24} style={{ marginTop: -20 }}>
              <span>OBS</span>
              <InputForm
                id="pi_obs"
                ref="pi_obs"
                value={pi_obs}
                type="textarea"
                rows={5}
                maxLength={400}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={this.onOK}
                  className="botoesModalForm2x"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onFecharModalProdutoClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrdemProducaoItemForm.js